import { createApi } from '@reduxjs/toolkit/query/react';
import {
  WorkspaceAPIResponse,
  WorkspaceIdUsageAPIResponse,
} from './WorkspaceAPI.model';
import axiosBaseQuery from '../../service/shared/axiosBaseQuery';
import { toBase64 } from '../../shared/util/base64';

const WorkspaceAPI = createApi({
  reducerPath: 'workspaceId',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'create-request',
    'cancel-self',
    'sales-team-actions',
    'workspace-actions',
    'workspace-usage',
  ],
  endpoints(build) {
    return {
      getMyWorkspaces: build.query<WorkspaceAPIResponse[], undefined>({
        query: () => ({ url: `workspace/self` }),
        providesTags: ['cancel-self', 'workspace-actions'],
      }),
      getWorkspaceById: build.query<WorkspaceAPIResponse, string>({
        query: (workspaceId) => ({ url: `workspace/${toBase64(workspaceId)}` }),
        providesTags: ['workspace-actions'],
      }),
      getWorkspaceUsage: build.query<WorkspaceIdUsageAPIResponse, string>({
        query: (workspaceId) => ({
          url: `workspace/${toBase64(workspaceId)}/usage`,
        }),
        providesTags: ['workspace-usage'],
      }),
      uploadImage: build.mutation<
        { url: string },
        { workspaceId: string; key: string; formData: FormData }
      >({
        query: ({ workspaceId, formData, key }) => ({
          url: `workspace/${toBase64(workspaceId)}/images/${key}`,
          method: 'PUT',
          data: formData,
        }),
        invalidatesTags: ['workspace-actions'],
      }),
      removeImage: build.mutation<void, { workspaceId: string; key: string }>({
        query: ({ workspaceId, key }) => ({
          url: `workspace/${toBase64(workspaceId)}/images/${key}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['workspace-actions'],
      }),
      updateSettings: build.mutation<
        WorkspaceAPIResponse | { error: string },
        {
          workspaceId: string;
          formData: Record<string, string | null | undefined>;
        }
      >({
        query: ({ workspaceId, formData }) => ({
          url: `workspace/${toBase64(workspaceId)}/settings`,
          method: 'PUT',
          data: formData,
        }),
        invalidatesTags: ['workspace-actions'],
      }),
    };
  },
});

export default WorkspaceAPI;
